// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"bcu_a bhm_b bhm_va bhm_rv bhm_rw bhm_vu","PanelFooter--link":"bcu_b"};